import { render, staticRenderFns } from "./ConfirmRedeemModal.vue?vue&type=template&id=2e53e572&scoped=true&"
import script from "./ConfirmRedeemModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmRedeemModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRedeemModal.vue?vue&type=style&index=0&id=2e53e572&lang=scss&scoped=true&"
import style1 from "./ConfirmRedeemModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e53e572",
  null
  
)

export default component.exports